export default __webpack_public_path__ + "static/media/gallery-image-1.bb9f54d4.png";